module.exports = __webpack_public_path__ + "img/registro-from-excel.3954f0dd.png";